module.exports = __webpack_public_path__ + "static/media/hero.b300623d.jpg";